var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"title"},[_c('a',{staticClass:"title__anchor",attrs:{"href":_vm.indexUrl}},[_c('span',{staticClass:"title__logo"}),_vm._v(" "),_c('span',{staticClass:"title__text"},[_vm._v("お店管理画面")])])])}
var staticRenderFns = []

export { render, staticRenderFns }